import { render, staticRenderFns } from "./StaffAttendancePageControl.vue?vue&type=template&id=5e1bb96a&scoped=true&"
import script from "./StaffAttendancePageControl.vue?vue&type=script&lang=js&"
export * from "./StaffAttendancePageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1bb96a",
  null
  
)

export default component.exports